import React, { useMemo, useState } from "react";
import { Check, ChevronDown, Search } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

export default function StudioSelect({
  value,
  onChange,
  options,
  placeholder = "Не выбрано",
  searchable = false,
  searchPlaceholder = "Найти…",
  testid,
}) {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");
  const selected = options.find((option) => option.value === value);
  const filtered = useMemo(() => {
    const needle = query.trim().toLocaleLowerCase("ru");
    if (!needle) return options;
    return options.filter((option) =>
      `${option.label} ${option.keywords || ""}`.toLocaleLowerCase("ru").includes(needle)
    );
  }, [options, query]);
  const commit = (next) => {
    onChange(next);
    setQuery("");
    setOpen(false);
  };

  return (
    <Popover open={open} onOpenChange={(next) => { setOpen(next); if (!next) setQuery(""); }}>
      <PopoverTrigger asChild>
        <button
          type="button"
          className="flex h-10 w-full min-w-0 items-center justify-between gap-2 rounded-lg bg-[#FBF5EA] px-3 text-left text-[13px]"
          style={{ boxShadow: "inset 0 0 0 1px #EFE4D0", color: selected ? "#2A1D14" : "#8B6F4B" }}
          data-testid={testid}
        >
          <span className="truncate">{selected?.label || placeholder}</span>
          <ChevronDown size={14} strokeWidth={1.8} className="shrink-0 text-[#8B6F4B]" />
        </button>
      </PopoverTrigger>
      <PopoverContent
        align="start"
        className="w-[var(--radix-popover-trigger-width)] min-w-[220px] max-w-[calc(100vw-24px)] overflow-hidden border-[#EFE4D0] bg-white p-0"
      >
        {searchable && (
          <div className="border-b border-[#EFE4D0] p-2">
            <div className="flex h-9 items-center gap-2 rounded-lg bg-[#FBF5EA] px-3 shadow-[inset_0_0_0_1px_#EFE4D0]">
              <Search size={13} className="shrink-0 text-[#8B6F4B]" />
              <input
                autoFocus
                value={query}
                onChange={(event) => setQuery(event.target.value)}
                placeholder={searchPlaceholder}
                className="min-w-0 flex-1 bg-transparent text-[13px] text-[#2A1D14] outline-none"
                data-testid={testid ? `${testid}-search` : undefined}
              />
            </div>
          </div>
        )}
        <div className="max-h-64 overflow-y-auto py-1">
          {filtered.map((option) => (
            <button
              key={option.value || "__empty"}
              type="button"
              onClick={() => commit(option.value)}
              className={`flex min-h-10 w-full items-center gap-2 px-3 py-2 text-left text-[13px] hover:bg-[#FBF5EA] ${option.value === value ? "bg-[#F5EBD8]" : ""}`}
              style={{ color: "#2A1D14" }}
              data-testid={testid ? `${testid}-option-${option.value || "empty"}` : undefined}
            >
              <span className="w-3 shrink-0">{option.value === value && <Check size={12} className="text-[#3E5236]" />}</span>
              <span className="min-w-0 break-words">{option.label}</span>
            </button>
          ))}
          {!filtered.length && <div className="px-3 py-4 text-[12px] text-[#8B6F4B]">Ничего не найдено.</div>}
        </div>
      </PopoverContent>
    </Popover>
  );
}
